import {LocalStorage} from '@wix/wix-events-commons-statics'

const CURRENT_ROUTE_LOCAL_STORAGE_KEY = 'currentPageRoute'

export const setCurrentRoute = (route: string) => LocalStorage.setItem(CURRENT_ROUTE_LOCAL_STORAGE_KEY, route)
